import React from "react";
import Resources from "../../types/Resources";
import Button from "../Common/Button";
import LoadingSpinner from "../Common/LoadingSpinner";
import { Date_toDateString } from "../../common/dateUtils";
import { SignatureManager } from "../../hooks/useSignature";

type SignatureDisplayProps = {
    resources: Resources;
    signatureLabel: string | undefined;
    containerClassName?: string;
    signatureManager: SignatureManager;
    showDate?: boolean;
};

function SignatureDisplay({
    signatureManager,
    resources,
    signatureLabel,
    containerClassName,
    showDate = false
}: SignatureDisplayProps) {
    if (signatureManager.hideSignature) {
        return null;
    }

    const {
        signature,
        signatureUrl,
        isLoading,
        disableSignButton,
        signButtonTooltip,
        removeSignatureButtonClickHandlerAsync,
        signButtonClickHandler
    } = signatureManager;

    const hasSignature: boolean = !!signature && (!!signature.id || !!signature.base64Signature);

    return (
        <div className={`${containerClassName} text-center mt-2`} style={{ width: 250 }}>
            {hasSignature ? (
                <div className="d-flex flex-column">
                    {signatureUrl && !isLoading ? (
                        <>
                            {signature.canRemove ? (
                                <div
                                    className="position-absolute d-flex justify-content-end"
                                    style={{ width: 260, marginTop: -10 }}
                                >
                                    <Button
                                        variant="danger"
                                        tooltip={resources.get("RemoveSignature")}
                                        onClick={removeSignatureButtonClickHandlerAsync}
                                        round
                                    >
                                        <i className="fas fa-xmark"></i>
                                    </Button>
                                </div>
                            ) : null}
                            <img src={signatureUrl} width={250} className="border rounded" />
                        </>
                    ) : (
                        <LoadingSpinner />
                    )}
                    <span>{signature.nameClarification}</span>
                    {signature.phoneNumber ? <span>{signature.phoneNumber}</span> : null}
                    <span className="text-nowrap">{signatureLabel}</span>
                    {showDate ? <span>{Date_toDateString(signature.createdAt)}</span> : null}
                </div>
            ) : (
                <>
                    <div>{resources.get("SignatureMissing")}</div>
                    <span className="text-nowrap">{signatureLabel}</span>
                    {signature && signature.canCreate ? (
                        <div>
                            <Button
                                disabled={disableSignButton}
                                onClick={signButtonClickHandler}
                                tooltip={signButtonTooltip}
                            >
                                {resources.get("AddSignature")}
                            </Button>
                        </div>
                    ) : null}
                </>
            )}
        </div>
    );
}

export default SignatureDisplay;
